import { TextField } from '@mui/material';
import React, { forwardRef } from 'react';

export const CustomTextField = forwardRef((props: any, ref) => {
    const { children, autoComplete, inputProps, ...rest } = props;
    return (
        <TextField
            inputProps={{
                autoComplete: 'none',
                ...inputProps,
            }}
            sx={{
                input: {
                    height: '5px',
                },
            }}
            {...rest}
            ref={ref}
            autoComplete={autoComplete ?? 'off'}
        >
            {children}
        </TextField>
    );
});
